module.exports = __webpack_public_path__ + "media/images/emblems/Mauborget-coat_of_arms-f69586b164dd72b71a4db165f760ab54.svg";